import { Button, Grid, withStyles } from "@material-ui/core";
import { t } from "adapters/i18n";
import { CustomTooltip } from "components/CustomTooltip";
import { PortalRoutes } from "constants/routes";
import history from "features/app/History";
import * as forragemActions from "features/manejo/redux/actions/forragemActions";
import * as moduloActions from "features/manejo/redux/actions/moduloActions";
import * as pastoActions from "features/manejo/redux/actions/pastoActions";
import * as pastoPrimeActions from "features/manejo/redux/actions/pastoPrimeActions";
import MensagemMenuLateral from "features/manejo/views/components/MensagemMenuLateral";
import { ManejoTab } from "features/manejo/views/components/Tabs/ManejoTab";
import { ManejoTabs } from "features/manejo/views/components/Tabs/ManejoTabs";
import { deveExibirCampoIdPrime } from "features/shared/utils";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import { enviaDadosGAPorRotulo } from "shared/utils";
import * as loteOperations from "../../../../../lote/redux/loteOperations";
import DialogAtualizacaoRetiroPasto from "./DialogAtualizacaoRetiroPasto";
import DialogExclusaoModuloDoPasto from "./DialogExclusaoModuloDoPasto";
import DialogExclusaoPasto from "./DialogExclusaoPasto";
import FormPasture from "./FormPasture";
import FormTrough from "./FormTrough";

export class PastureRegistrations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      aba: 0,
      isEdit: this.props.isEdit,
      Desenhando: this.props.Desenhando,
      ModalConfirmacaoExclusao: false,
      IdRetiroAlterado: false,
    };
  }

  async loadPastureForm() {
    const { PastoSelecionado, setTrough, setCreepTrough } = this.props;

    if (!PastoSelecionado) {
      return;
    }

    if (this.props.listarPastosPrime) {
      await this.props.listarPastosPrime(PastoSelecionado.IdFazenda);
    }

    this.props.setPasture({
      ...PastoSelecionado,
      IdFazenda: this.props.IdFazenda,
      IdPastoPrime: PastoSelecionado.IdPastoPrime
        ? PastoSelecionado.IdPastoPrime
        : 0,
    });

    if (!PastoSelecionado.IdPasto) {
      return;
    }

    await this.props.listarLotes(this.props.PastoSelecionado.IdPasto);

    const cochoCreep = PastoSelecionado.PastoCochos
      ? PastoSelecionado.PastoCochos.find(
          (e) => e.CochoCreep && !e.DataExclusao && !e.PastoCocho.DataValidade,
        )
      : null;

    const cocho = PastoSelecionado.PastoCochos
      ? PastoSelecionado.PastoCochos.find(
          (e) => !e.CochoCreep && !e.DataExclusao && !e.PastoCocho.DataValidade,
        )
      : null;

    setTrough(cocho);
    setCreepTrough(cochoCreep);
    this.setState({ aba: 0 });
  }

  componentDidMount = async () => {
    if (this.props.Desenhando && this.props.desabilitarDesenhar) {
      this.props.desabilitarDesenhar();
    }

    await this.props.obterForragem();
    await this.loadPastureForm();
  };

  componentDidUpdate(nextProps) {
    if (this.props.pasture.IdPasto && !this.props.PastoSelecionado.IdPasto) {
      history.replace(PortalRoutes.PASTURE_REGISTRATIONS);
    }

    if (
      nextProps.PastoSelecionado.IdPasto !==
        this.props.PastoSelecionado.IdPasto &&
      this.props.pasture.IdPasto !== this.props.PastoSelecionado.IdPasto
    ) {
      this.loadPastureForm();
    }
  }

  componentWillUnmount = () => {
    if (this.props.cadastroPastoModificado) {
      this.props.modificarCadastroPasto(false);
    }

    const desenhos = Array.isArray(this.props.CoordenadasNovosPastos)
      ? this.props.CoordenadasNovosPastos
      : [];

    desenhos.forEach((coord) => {
      if (coord && coord.Evento && this.props.deletarPoligono) {
        this.props.deletarPoligono(coord.Evento, coord.Id);
      }
    });

    if (this.props.desabilitarDesenhar) {
      this.props.desabilitarDesenhar();
    }

    if (this.props.errosPasto.ExcluirModuloAlterandoRetiro) {
      this.props.limparErroExcluirModuloPelaAlteracaoRetiro();
    }
    if (this.props.errosPasto.ExcluirModuloAoExcluirPasto) {
      this.props.limparErroExcluirModuloPelaExclusaoPasto();
    }
    this.setState({ IdRetiroAlterado: false });
  };

  handleChangeAba = (event, aba) => {
    this.setState({ aba });
  };

  handleChangeFormBasico = (propertyName, event) => {
    const { cadastroPastoModificado, pasture } = this.props;
    this.props.setPasture({
      ...this.props.pasture,
      [propertyName]: event.target.value,
    });
    if (!cadastroPastoModificado) {
      this.props.modificarCadastroPasto(true);
    }
    if (pasture.IdModulo && propertyName === "IdRetiro") {
      this.setState({ IdRetiroAlterado: true });
    }
  };

  handleChangeFormCocho = (propertyName, event) => {
    const { cadastroPastoModificado, trough, setTrough } = this.props;
    setTrough({ ...trough, [propertyName]: event.target.value });
    if (!cadastroPastoModificado) {
      this.props.modificarCadastroPasto(true);
    }
  };

  handleChangeFormCochoCreep = (propertyName, event) => {
    const { cadastroPastoModificado, creepTrough, setCreepTrough } = this.props;
    setCreepTrough({
      ...creepTrough,
      [propertyName]: event.target.value,
      CochoCreep: true,
      IdCocho: null,
      IdPasto: this.props.pasture.IdPasto,
    });
    if (!cadastroPastoModificado) {
      this.props.modificarCadastroPasto(true);
    }
  };

  handleAbrirModalExclusao = () => {
    this.setState({ ModalConfirmacaoExclusao: true });
  };

  recarregarCadastro = () => {
    history.replace("/cadastro");
  };

  handleBack = (coord) => {
    if (this.props.onBack) {
      this.props.onBack();
    } else {
      if (coord && coord.length > 0) {
        this.props.deletarPoligono(coord[0].Evento, coord[0].Id);
      }
      history.replace("/cadastro");
    }
  };

  handleFechaModalExclusao = () => {
    this.setState({ ModalConfirmacaoExclusao: false });
  };

  handleExcluiPasto = () => {
    const { IdPasto, IdFazenda } = this.props.pasture;
    this.props.excluiPasto(IdPasto, IdFazenda);
    this.setState({ ModalConfirmacaoExclusao: false });
    const acao = "Excluir";
    const rotulo = "Pasto";
    const categoria = "Cadastro";
    enviaDadosGAPorRotulo(acao, rotulo, categoria);
  };

  handleExcluiPastoComModulo = async () => {
    const { IdPasto, IdModulo, IdFazenda } = this.props.pasture;
    await this.props.excluirModulo(IdModulo, IdFazenda);
    await this.props.excluiPasto(IdPasto, IdFazenda);
    this.setState({ ModalConfirmacaoExclusao: false });
    const acao = "Excluir";
    const rotulo = "Pasto";
    const categoria = "Cadastro";
    enviaDadosGAPorRotulo(acao, rotulo, categoria);
  };

  handleConfirmarExclusaoModuloAlterandoRetiro = async () => {
    const { pasture, trough } = this.props;
    await this.props.excluirModulo(pasture.IdModulo, pasture.IdFazenda);
    await this.props.salvarCadastroPasto(
      { ...pasture, IdModulo: null },
      { ...trough, IdPasto: pasture.IdPasto },
    );
  };

  handleFechaConfirmarExclusaoModulo = () => {
    this.props.limparErroExcluirModuloPelaAlteracaoRetiro();
  };

  handleFechaModalExclusaoComModulo = () => {
    this.props.limparErroExcluirModuloPelaExclusaoPasto();
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    const { pasture, trough, creepTrough } = this.props;

    if (pasture.IdPasto) {
      if (creepTrough) {
        await this.props.salvarCadastroPasto(pasture, creepTrough);
      }
      await this.props.salvarCadastroPasto(pasture, trough);
    } else {
      const sucesso = await this.props.novoPasto(pasture, trough, creepTrough);
      if (!sucesso) {
        return;
      }
    }

    this.props.setPasture({
      Nome: "",
      NomeReduzido: "",
      AreaAberta: "",
      AreaEfetiva: "",
      PotencialDeProducao: "",
      IdPastoPrime: null,
    });
    const acao = "Cadastrar pasto";
    const rotulo = "Salvar pasto";
    const categoria = "Mapa";
    enviaDadosGAPorRotulo(acao, rotulo, categoria);
    this.props.limparCoordenadasEditando([]);
    this.recarregarCadastro();
  };

  montarDropdownPastosPrime = (pastosPrime) => {
    let dropdownPastosPrime = [
      {
        value: 0,
        key: t("pasture:not-linked"),
      },
    ];
    if (pastosPrime) {
      pastosPrime.forEach((item) => {
        let pastoPrime = {
          value: item.IdPastoPrime,
          key: item.Nome,
        };
        dropdownPastosPrime.push(pastoPrime);
      });
    }
    return dropdownPastosPrime;
  };

  buscarPastosPrime = async (IdFazenda) => {
    if (this.props.listarPastosPrime) {
      await this.props.listarPastosPrime(IdFazenda);
    }
  };

  tabPasture = () => {
    const {
      IdFazenda,
      IdRetiro,
      errosPasto,
      Retiros,
      Forragens,
      exibirCampoIdPrime,
      PastosPrime,
      pasture,
      habilitarDesenhar,
      AreaNovoPasto,
    } = this.props;

    const pastosPrimeDropDown = this.montarDropdownPastosPrime(PastosPrime);

    return (
      <Grid container direction="row" spacing={12}>
        <Grid item xs={12}>
          <FormPasture
            id="formBasico"
            Pasto={pasture}
            IdRetiro={IdRetiro}
            PastosPrime={pastosPrimeDropDown}
            IdFazenda={IdFazenda}
            errosValidacao={errosPasto}
            Retiros={Retiros}
            Forragens={Forragens}
            exibirCampoIdPrime={exibirCampoIdPrime}
            handleChangeFormBasico={this.handleChangeFormBasico}
            habilitarDesenhar={habilitarDesenhar}
            AreaNovoPasto={AreaNovoPasto}
          />
        </Grid>
      </Grid>
    );
  };

  tabTrough = () => {
    const {
      errosCocho,
      Toggles,
      trough,
      creepTrough,
      exibirCarregando,
      notifyError,
    } = this.props;
    return (
      <div>
        <FormTrough
          id="formCocho"
          Cocho={trough}
          CochoCreep={creepTrough}
          Toggles={Toggles}
          errosValidacao={errosCocho}
          handleChangeFormCocho={this.handleChangeFormCocho}
          handleChangeFormCochoCreep={this.handleChangeFormCochoCreep}
          handleClearCochoCreepForm={this.handleClearCochoCreepForm}
          exibirCarregando={exibirCarregando}
          notifyError={notifyError}
        />
      </div>
    );
  };

  validatePastureCanSave = (pasture, openedArea) => {
    const pastureOpenedArea = openedArea
      ? openedArea
      : pasture.IdPasto && pasture.AreaAberta
        ? pasture.AreaAberta
        : "";

    return (
      pasture.Nome &&
      pasture.Nome.trim() &&
      pasture.IdForragem &&
      pasture.IdRetiro &&
      pastureOpenedArea &&
      pastureOpenedArea !== ""
    );
  };

  controlButtons = () => {
    const { classes, CoordenadasNovosPastos, pasture, AreaNovoPasto } =
      this.props;

    const saveButtonDisabled = !this.validatePastureCanSave(
      pasture,
      AreaNovoPasto,
    );

    return (
      <div direction="row" spacing={12} className={classes.buttonsContainer}>
        {!pasture.IdPasto ? (
          <Button
            id="botaoExcluir"
            variant="outlined"
            color="primary"
            className={classes.button}
            onClick={() => this.handleBack(CoordenadasNovosPastos)}
          >
            {t("common:actions.go-back")}
          </Button>
        ) : (
          <Button
            id="botaoExcluir"
            variant="outlined"
            className={[classes.botaoExcluir, classes.button].join(" ")}
            onClick={this.handleAbrirModalExclusao}
          >
            {t("pasture:delete-pasture")}
          </Button>
        )}

        <CustomTooltip
          disableHoverListener={!saveButtonDisabled}
          placement="right"
          title={t("pasture:fill-required-fields-to-save")}
        >
          <span
            className={[classes.saveButtonWrapper, classes.buttonWrapper].join(
              " ",
            )}
          >
            <Button
              id="botaoSalvar"
              variant="contained"
              color="primary"
              classes={{ disabled: classes.saveButtonDisabled }}
              className={classes.button}
              disabled={saveButtonDisabled}
              onClick={this.handleSubmit}
            >
              {t("pasture:save-pasture")}
            </Button>
          </span>
        </CustomTooltip>
      </div>
    );
  };

  handleClearCochoCreepForm = () => this.props.setCreepTrough(null);

  render() {
    const { classes, errosPasto, Lotes, PastoSelecionado, isEdit } = this.props;
    const { aba, ModalConfirmacaoExclusao } = this.state;

    const canShowForm = (isEdit && PastoSelecionado.IdPasto) || !isEdit;

    return (
      <form
        id="menuCadastro"
        noValidate
        autoComplete="off"
        className={classes.form}
      >
        <div className={classes.root}>
          <ManejoTabs
            id="tabController"
            value={this.state.aba}
            onChange={this.handleChangeAba}
            indicatorColor="primary"
            fullWidth
          >
            <ManejoTab
              disabled={!canShowForm}
              id="tabBasicoCadastroPasto"
              label={t("pasture:pasture")}
            />
            <ManejoTab
              disabled={!canShowForm}
              id="tabAvancadoCadastroPasto"
              label={t("pasture:trough")}
            />
          </ManejoTabs>

          <div className={classes.formContent}>
            <div direction="row" spacing={12} className={classes.tabsContent}>
              {!canShowForm && (
                <MensagemMenuLateral
                  id="selectPastureToEditMessage"
                  mensagem={t("pasture:select-pasture-to-edit")}
                  childrenContainerClass={classes.imageMessage}
                  mensagemClass={classes.message}
                >
                  <img
                    src="../images/map_indicator.svg"
                    alt={t("pasture:map-icon-alt")}
                  />
                </MensagemMenuLateral>
              )}
              {canShowForm && aba === 0 && this.tabPasture()}
              {canShowForm && aba === 1 && this.tabTrough()}
            </div>

            {canShowForm && this.controlButtons()}
          </div>
        </div>

        <DialogExclusaoPasto
          id="dialogExclusaoPasto"
          ContemLote={Lotes !== undefined && Lotes.length > 0}
          ModalConfirmacaoExclusao={ModalConfirmacaoExclusao}
          handleFechaModalExclusao={this.handleFechaModalExclusao}
          handleExcluiPasto={this.handleExcluiPasto}
        />
        <DialogAtualizacaoRetiroPasto
          ExcluirModuloAlterandoRetiro={errosPasto.ExcluirModuloAlterandoRetiro}
          handleFechaConfirmarExclusaoModulo={
            this.handleFechaConfirmarExclusaoModulo
          }
          handleConfirmarExclusaoModuloAlterandoRetiro={
            this.handleConfirmarExclusaoModuloAlterandoRetiro
          }
        />
        <DialogExclusaoModuloDoPasto
          ExcluirModuloAoExcluirPasto={errosPasto.ExcluirModuloAoExcluirPasto}
          handleFechaModalExclusaoComModulo={
            this.handleFechaModalExclusaoComModulo
          }
          handleExcluiPastoComModulo={this.handleExcluiPastoComModulo}
        />
      </form>
    );
  }
}

PastureRegistrations.propTypes = {
  classes: PropTypes.object.isRequired,
  PastoSelecionado: PropTypes.object.isRequired,
  IdRetiro: PropTypes.number.isRequired,
  IdFazenda: PropTypes.number.isRequired,
  Retiros: PropTypes.array,
};

const mapDispatchToProps = {
  deletarPoligono: pastoActions.deletarPoligono,
  desabilitarDesenhar: pastoActions.desabilitarDesenhar,
  excluiPasto: pastoActions.excluiPasto,
  excluirModulo: moduloActions.excluirModulo,
  habilitarDesenhar: pastoActions.habilitarDesenhar,
  limparCoordenadasEditando: pastoActions.editandoCoordenadasPasto,
  limparErroExcluirModuloPelaAlteracaoRetiro:
    pastoActions.limparErroExcluirModuloPelaAlteracaoRetiro,
  limparErroExcluirModuloPelaExclusaoPasto:
    pastoActions.limparErroExcluirModuloPelaExclusaoPasto,
  listarLotes: loteOperations.listaLotesPasto,
  listarPastosPrime: pastoPrimeActions.listarPastosPrime,
  modificarCadastroPasto: pastoActions.modificarCadastroPasto,
  novoPasto: pastoActions.novoPasto,
  obterForragem: forragemActions.obterTodasForragens,
  salvarCadastroPasto: pastoActions.salvarCadastroPasto,
};

const mapStateToProps = (state) => ({
  AreaNovoPasto: state.pasto.AreaNovoPasto,
  CoordenadasNovosPastos: state.pasto.CoordenadasNovoPasto,
  Desenhando: state.pasto.Desenhando,
  exibirCampoIdPrime: deveExibirCampoIdPrime(state),
  Lotes: state.lote.LotesPorPasto,
});

const styles = () => ({
  form: {
    height: "100%",
    width: "100%",
  },
  root: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  tabsContent: {
    flexGrow: 1,
    marginTop: 24,
  },
  buttonsContainer: {
    alignSelf: "end",
    marginTop: 40,
  },
  botaoExcluir: {
    color: "#ff0202",
    padding: "7px 22px",
    height: 36,
    border: "solid 1px #ff0202",
  },
  button: {
    minWidth: 150,
  },
  saveButtonWrapper: {
    marginStart: "24px",
  },
  saveButtonDisabled: {
    backgroundColor: "rgba(0, 83, 160, 0.5) !important",
    color: "#FFF !important",
  },
  imageMessage: {
    padding: 0,
    margin: 40,
  },
  message: {
    maxWidth: 263,
    fontFamily: "Roboto",
    fontSize: "16px",
    fontWeight: "normal",
    lineHeight: 1.5,
    letterSpacing: "normal",
    textAlign: "justify",
    color: "#212121",
  },
  formContent: {
    display: "flex",
    paddingBottom: "32px",
    flex: 1,
    flexDirection: "column",
  },
  tooltip: {
    width: "257px",
    padding: "16px",
    borderRadius: "4px",
    backgroundColor: "#616161",
    fontFamily: "Roboto",
    fontSize: "14px",
  },
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps),
)(PastureRegistrations);
